

export default function LocStr$(id: string, defStr?: string) {
	return defStr === undefined ? id : defStr;
}
